export default "__VITE_ASSET__CfsAretD__"